module.exports = __webpack_public_path__ + "static/media/logo-sh.0d397fba.png";